import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { object, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Gallery, SanitizedHtml } from 'components';
import { formatLocalizedCurrency, getTravelOption } from 'helpers';
import { appService } from 'services';

const PrintTravelShowPage = ({ travel, tabs, className = '' }) => {
  const isTouloisirsTravel = travel?.tourOperator === 'Touloisirs';

  const { t } = useTranslation();

  if (!travel) return null;

  return (
    <div className={clsx('product-show bg-white m-[0.5cm]', className)}>
      <img
        className="w-auto h-14 mx-auto mb-6"
        src={appService.loadBrandImage('logo')}
        alt={t(`images.${appService.brand()}.logoAlt`)}
        width="154"
        height="56"
      />

      <Gallery images={travel?.visuals} />

      <div className="pt-12">
        <h2 className="h2 underlined-blue mb-8">{t('yourTravel')}</h2>

        <ul className="mb-8">
          <li className="list-disc mb-4">
            <span>{t('fromPrice')}</span>
            <span className="font-bold mx-2">
              {formatLocalizedCurrency(isTouloisirsTravel ? travel.priceNotC2C : travel.price)}
            </span>
            <span>{t('unitPrice')}</span>
          </li>

          {travel?.options?.map((option, i) => {
            const travelOption = getTravelOption(option);
            if (isEmpty(travelOption?.i18n?.key)) return null;
            return (
              <li key={`travel-option-${i}`} className="list-disc mb-4">
                {t(travelOption?.i18n?.key, travelOption?.i18n?.data)}
              </li>
            );
          })}
        </ul>

        <h2 className="h2 underlined-blue mb-8">{travel?.title}</h2>

        {isTouloisirsTravel ? (
          <SanitizedHtml content={travel?.presentation} />
        ) : (
          <SanitizedHtml content={travel?.resume} />
        )}

        {tabs.details.length > 0 && (
          <>
            <h2 className="h2 underlined-blue mb-10">{t('products:details')}</h2>

            {tabs.details.map((tab, i) => (
              <div key={`travel-details-tab-${i}`}>
                <h3 className="h3 my-4">{tab.label}</h3>

                <SanitizedHtml content={travel?.[tab.identifier]} />
              </div>
            ))}
          </>
        )}

        {tabs.tarifs.length > 0 && (
          <>
            <h2 className="h2 underlined-blue mb-10">{t('products:tarif')}</h2>

            {tabs.tarifs.map((tab, i) => (
              <div key={`travel-tarif-tab-${i}`}>
                <h3 className="h3 my-4">{tab.label}</h3>

                <SanitizedHtml content={travel?.[tab.identifier]} />
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

PrintTravelShowPage.propTypes = {
  travel: object,
  tabs: object,
  className: string
};

export default PrintTravelShowPage;
